import { Theme } from '@mui/material';

import { DisableTemplatePaddingOn, TRoundedCornersSize, Maybe } from '@/types';
const getOrder = (imgDisplaysFirst: boolean) => ({
	'[data-testid="section_content_service_line_hero"]': {
		order: imgDisplaysFirst ? 1 : 0,
	},
	'[data-testid="service_line_hero_video_asset"], [data-testid="service_line_hero_focal_point_image"],[data-testid="service_line_hero_image_asset"]':
		{
			order: imgDisplaysFirst ? 0 : 1,
		},
});

export const getContainerStyles = (
	theme: Theme,
	disablePaddingOn: DisableTemplatePaddingOn,
	imgDisplaysFirstOnMobile: boolean,
	imgDisplaysFirstOnDesktop: boolean,
	bgColor: Maybe<string>
) => ({
	paddingBottom: '11.875rem', // 190px -> 11.875rem
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'stretch',
	margin: '0 auto',
	boxSizing: 'border-box',
	position: 'relative',
	background: bgColor,
	...getOrder(imgDisplaysFirstOnDesktop),
	[theme.breakpoints.down('md')]: {
		paddingBottom: '11.875rem', // 190px -> 11.875rem
		flexDirection: 'column',
		...getOrder(imgDisplaysFirstOnMobile),
	},
});

export const getMediaBorderRadius = (
	mediaWithBorderRadius: Maybe<boolean>,
	imgDisplaysFirstOnDesktop?: Maybe<boolean>,
	mediaRoundedCornerSize?: Maybe<TRoundedCornersSize>
): string => {
	const radiusValues = {
		Small: 1,
		Medium: 2.5,
		Large: 5,
	} as { [key: string]: number };
	const radiusValue = radiusValues[mediaRoundedCornerSize ?? 'Large'];
	const rads = `${radiusValue}rem`;
	const leftRightRadius = imgDisplaysFirstOnDesktop ? `0 ${rads} ${rads} 0` : `${rads} 0 0 ${rads}`;
	return mediaWithBorderRadius === false ? 'none' : leftRightRadius;
};

interface IMediaContainerStyles {
	theme: Theme;
	mediaWithBorderRadius: Maybe<boolean>;
	isVideo?: boolean;
	imgDisplaysFirstOnDesktop?: Maybe<boolean>;
	mediaRoundedCornerSize?: Maybe<TRoundedCornersSize>;
}

export const getMediaContainerStyles = ({
	theme,
	mediaWithBorderRadius = false,
	isVideo = false,
	imgDisplaysFirstOnDesktop = false,
	mediaRoundedCornerSize,
}: IMediaContainerStyles) => {
	return {
		...(isVideo && { position: 'relative', containerType: 'inline-size' }),
		display: 'block',
		flex: '1',
		width: '100%',
		overflow: 'hidden',
		borderRadius: 'none',
		minHeight: 'auto',
		marginLeft: '2.75rem', // 44px -> 2.75rem
		marginBottom: '2.5rem', // 40px -> 2.5rem
		[theme.breakpoints.up('md')]: {
			borderRadius: getMediaBorderRadius(
				mediaWithBorderRadius,
				imgDisplaysFirstOnDesktop,
				mediaRoundedCornerSize
			),
			minHeight: '25rem', // 400px -> 25rem
		},
		[theme.breakpoints.down('sm')]: {
			marginX: '0rem', // 0px -> 0rem
		},
	};
};

export const getImageStyles = (theme: Theme) => ({
	borderRadius: '5rem 0 0 5rem',
	[theme.breakpoints.down('md')]: {
		borderRadius: '0',
	},
});

export const mobileImageStyles = {
	display: 'flex',
	borderRadius: '0',
};

export const teamTagEyebrowOverrideStyles = {
	fontWeight: 700,
	letterSpacing: '0.1875rem', // 3px -> 0.1875rem
	fontFamily: 'Messina Sans',
};
